var map = {
	"./copy-to-clipboard.ts": [
		"./client/prism/plugins/copy-to-clipboard.ts",
		26
	],
	"./edit.ts": [
		"./client/prism/plugins/edit.ts",
		28
	],
	"./filename.ts": [
		"./client/prism/plugins/filename.ts",
		29
	],
	"./line-highlight.ts": [
		"./client/prism/plugins/line-highlight.ts",
		0
	],
	"./line-numbers.ts": [
		"./client/prism/plugins/line-numbers.ts",
		1
	],
	"./show-invisibles.ts": [
		"./client/prism/plugins/show-invisibles.ts",
		2
	],
	"./toolbar.ts": [
		"./client/prism/plugins/toolbar.ts",
		27
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./client/prism/plugins lazy recursive ^\\.\\/.*\\.ts$";
module.exports = webpackAsyncContext;